import { render, staticRenderFns } from "./firmwareTask_addItem.vue?vue&type=template&id=10298ae0"
import script from "./firmwareTask_addItem.vue?vue&type=script&lang=js"
export * from "./firmwareTask_addItem.vue?vue&type=script&lang=js"
import style0 from "./firmwareTask_addItem.vue?vue&type=style&index=0&id=10298ae0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports